// Dependencies
import { Component } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { connect } from 'react-redux';

import { TIME_MODE_RANG_HOURS } from 'data/static';
import { bindActionCreators, Dispatch } from 'redux';
import {
    SetErrorHandlerAction,
    setErrorHandlerAction,
    SetSystemLoadingAction,
    setSystemLoadingAction,
} from 'store/actions/errorsActions';
import { SetLayoutAction, setLayoutAction } from 'store/actions/layoutActions';
import {
    InterfaceVariablesType,
    Layout,
    PortShipType,
    PortType,
    RootState,
    SwitchType,
    TransitType,
    UserType,
} from 'types';
import { MainControlsInterface, MapControlsInterface } from 'types/functions';
import { SystemType } from 'types/system';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { checkDifferent, checkLayoutDifferent, clone, getId } from 'utils/formHandlers';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';
import PlaybackTransitTab from './tabs/PlaybackTransitTab';

//Leave the old data as it is needed in the new menu.
interface PlaybackMenuComponentProps {
    layout: Layout;
    active: boolean;

    setLayoutAction: SetLayoutAction;
    setErrorHandlerAction: SetErrorHandlerAction;
    setSystemLoadingAction: SetSystemLoadingAction;
    port: PortType;
    mode: string;
    system: SystemType;
    switchs: SwitchType;
    dateTimeFormat: DateTimeFormat;
    mapControls: MapControlsInterface;

    user: UserType;

    mainControls: MainControlsInterface;
}

//Leave the old data as it is needed in the new menu.
interface PlaybackMenuComponentState {
    layout: Layout;
    active: boolean;
    switchs: SwitchType;

    startTime: DateTimeFormat;
    endTime: DateTimeFormat;
    interfaceVariables: InterfaceVariablesType;
    selectedTime?: DateTimeFormat | null;
    tracks: any[];
    portShips?: PortShipType[];
    transitShips?: PortShipType[];
    minimumLength: number;
    mode: string;
    system: SystemType;
    groups: {
        id: string;
        name: string;
        active: boolean;
        total: number;
        display?: boolean;
        trackLoaded?: boolean;
        drawTrack?: boolean;
    }[];
    tab: string;
    searchId: string;
    transits: TransitType[];
}

class PlaybackMenu extends Component<PlaybackMenuComponentProps, PlaybackMenuComponentState> {
    constructor(props: PlaybackMenuComponentProps) {
        super(props);
        this.state = {
            //Leave the old data as it is needed in the new menu.
            layout: clone(props.layout),
            switchs: clone(props.switchs),
            interfaceVariables: props.port.meta_data.interfaceVariables,

            active: props.active,
            system: props.system,
            mode: '',
            portShips: props.port.port_ships,
            transitShips: props.port.transit_ships,
            minimumLength: props.port.minimum_length | 40,
            tracks: [],
            startTime: props.system.date.today.clone().minus({ hours: TIME_MODE_RANG_HOURS }),
            endTime: props.system.date.today.clone(),
            selectedTime: props.system.date.today.clone().minus({ minutes: 10 }),
            groups: [
                { name: 'transitVessels', id: getId(), active: true, total: 0 },
                { name: 'portVessels', id: getId(), active: false, total: 0 },
                { name: 'otherVessels', id: getId(), active: false, total: 0 },
            ],
            tab: 'transitList',
            searchId: '',
            transits: [],
        };
    }

    static getDerivedStateFromProps(props: PlaybackMenuComponentProps, state: PlaybackMenuComponentState) {
        if (checkDifferent(props.switchs, state.switchs, true)) {
            return { switchs: clone(props.switchs) };
        }

        if (checkDifferent(props.system, state.system)) {
            return { system: props.system };
        }

        if (
            props.active !== state.active ||
            props.mode !== state.mode ||
            checkLayoutDifferent(props.layout, state.layout, ['sections.playback.menus.playbackMenu', 'searchId'])
        ) {
            return {
                transits: props.mainControls.getTransit(0),
                searchId: props.layout.searchId,
                active: props.active,
                layout: clone(props.layout),
                mode: props.mode,
            };
        }

        return null;
    }

    // changeTab = (tab: string) => {
    //     if (!this.state.layout.sections.playback.menus.playbackMenu.sections[tab].state) {
    //         return;
    //     }

    //     this.props.setLayoutAction([
    //         {
    //             action: 'UPDATE_MENU_SECTION',
    //             data: {
    //                 menu: 'playbackMenu',
    //                 section: 'playback',
    //                 name: tab,
    //                 state: true,
    //                 selected: true,
    //             },
    //         },
    //     ]);
    // };

    render() {
        return (
            <div
                className={twclsx(
                    this.state.active ? 'left-0 ' : 'left-out',
                    'mt-14',
                    'h-page',
                    'border-r',
                    'border-gray-300',
                    'position-transition',
                    'fixed',
                    'z-20',
                    'w-smallMenu',
                    'ml-subMenu',
                    'h-page',
                    'top-0',
                    'bg-white'
                )}
            >
                <div className="flex justify-between border-b border-gray-300 py-3  px-2">
                    <div className="text-lg font-bold">
                        {translate(
                            Object.keys(this.state.layout.sections.playback.menus.playbackMenu.sections).find(
                                (key) => this.state.layout.sections.playback.menus.playbackMenu.sections[key].state
                            )
                        )}
                    </div>
                    {/*hash close menu 'x'*/}
                    {/* <div
                        onClick={() => {
                            this.props.setLayoutAction([
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'playbackMenu',
                                        section: 'playback',
                                        state: !this.state.layout.sections.playback.menus.playbackMenu.state,
                                    },
                                },
                            ]);
                        }}
                        className="cursor-pointer"
                    >
                        <Icon>
                            <path d="M15 6l-6 6l6 6"></path>
                        </Icon>
                    </div> */}
                </div>
                <Scrollbars
                    autoHide
                    renderThumbVertical={({ style, ...props }) => (
                        <div
                            {...props}
                            style={{
                                ...style,
                                borderRadius: 5,
                                background: '#0000004a',
                                zIndex: 30, // Custom z-index
                                position: 'relative', // Required for z-index to work
                            }}
                        />
                    )}
                    className="w-full h-menu"
                >
                    <PlaybackTransitTab active={true}></PlaybackTransitTab>
                </Scrollbars>
            </div>
        );
    }
}

const playbackMenuStateToProps = (state: RootState) => ({
    layout: state.layout.layout,
    port: state.port.port,
    dateTimeFormat: state.port.dateTimeFormat,
    system: state.port.system,
    switchs: state.layout.switchs,
    mapControls: state.map.mapControls,
    mode: state.layout.mode,
    user: state.user.user,
    mainControls: state.layout.mainControls,
});

const playbackMenuDispatchToProps = (dispatch: Dispatch) => ({
    setSystemLoadingAction: bindActionCreators(setSystemLoadingAction, dispatch),
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
});

export default connect(playbackMenuStateToProps, playbackMenuDispatchToProps)(PlaybackMenu);
